<script lang="ts">
  import { bertekLogo } from "../constants/images";
  import { version } from "../../package.json";
  import HomeIcon from "./icons/Home.svelte";
  import LogOutIcon from "./icons/LogOut.svelte";
  import Logout from "../modules/authentication/presentation/page/Logout.svelte";
  import Link from "./RouteLink.svelte";

  export let back = false;
  let isOpen = false;
</script>

<header aria-label="CocoLake">
  <div class="left">
    <Link to="/">
      <img src={bertekLogo} alt="Bertek" width="2503" height="613" />
    </Link>
    {#if back}
      <Link to="/">
        <span class="icon" role="img" aria-label="Home" title="Home"><HomeIcon /></span>
      </Link>
    {/if}
  </div>
  <div class="brand">
    <span class="wordmark">Coco<span class="accent">Lake</span></span>
    <span class="version" aria-label={`Version ${version}`}>v{version}</span>
  </div>
  <button type="button" class="icon logout" aria-label="Log out" on:click={() => (isOpen = true)}>
    <LogOutIcon />
  </button>
</header>

<Logout bind:isOpen />

<style lang="scss">
  header {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    padding: 2rem;
    gap: 1rem;
    background: #0a0a0a;
    color: #fff;
    border-bottom: 1px solid #2d2d2d;
  }
  .left {
    display: flex;
    align-items: center;
    gap: 1.6rem;
    min-width: 0;
    height: 3rem;
  }
  .icon {
    position: relative;
    cursor: pointer;
    display: block;
    color: inherit;
    height: 3rem;
    width: 3rem;
    flex-shrink: 0;
    &:hover { color: #36f778; }
  }
  .logout { justify-self: end; }
  .brand {
    display: flex;
    align-items: baseline;
    gap: 1.2rem;
    white-space: nowrap;
  }
  .wordmark {
    font-family: "Space Grotesk", Arial, sans-serif;
    font-size: 3rem;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.1rem;
  }
  .accent { color: #36f778; }
  .version {
    font-family: "JetBrains Mono", Consolas, monospace;
    color: #b5b5b5;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1;
  }
  img {
    display: block;
    width: 11.2rem;
    height: auto;
  }
  @media (max-width: 480px) {
    header { grid-template-columns: auto 1fr auto; }
    .left { gap: 0.8rem; }
    .brand { justify-self: center; gap: 0.6rem; }
    .wordmark { font-size: 2.2rem; }
    .version { font-size: 1.1rem; }
    img { width: 80px; }
  }
</style>
